<template>
    <div class="preview-notice">
        <div class="topNav">
            <el-button size="mini" @click="()=> { $router.back(-1) }">返回</el-button>
            <span v-has="'02000003'" class="margin-left">
                <el-button size="mini" class="el-button el-button--primary"
                    v-if="noticeInfo.noticeType === NOTICE_TYPE_BID && timeFlag && (!noticeInfo.supplierBidStatus || noticeInfo.supplierBidStatus === '14') && signableForBlack"
                    @click="signUpFn()" :disabled="signload">我要报名</el-button>
            </span>
            <!-- 项目公告 我要报名 -->
            <span v-has="'02000003'" class="margin-left">
                <el-button size="mini" class="el-button el-button--primary"
                    v-if="noticeInfo.noticeType === NOTICE_TYPE_PROJECT && timeFlag && !noticeInfo.supplierBidStatus"
                    @click="signUpFn(NOTICE_TYPE_PROJECT)" :disabled="signload">我要报名</el-button>
            </span>
            <span v-has="'02000004'" class="margin-left">
                <el-button size="mini" class="el-button el-button--primary" v-if="noticeInfo.noticeType === NOTICE_TYPE_BID && timeFlag && noticeInfo.supplierBidStatus === '2'"
                    @click="buyBid">购买标书</el-button>
            </span>
        </div>
        <div class="content">
            <div class="title">{{noticeInfo.noticeTitle}}</div>
            <div class="content-box">
                <span class="color-9">公告类型：</span><span class="content-span">{{noticeInfo.noticeTypeText}}</span>
                <span class="color-9">发布时间：</span><span class="content-span">{{noticeInfo.createTime}}</span>
                <template v-if="noticeInfo.noticeType === NOTICE_TYPE_BID || noticeInfo.noticeType === NOTICE_TYPE_PROJECT">
                    <span class="color-9">报名截止时间：</span>
                    <span class="content-span">{{noticeInfo.enrollEndTime}}</span>
                </template>
                <template v-if="noticeInfo.noticeType === NOTICE_TYPE_BID">
                    <span class="color-9">标书购买开始时间：</span>
                    <span class="content-span">{{noticeInfo.buyStartTime}}</span>
                </template>
            </div>
            <div class="cont-mb">
                <div class="cont-mb-title title">公告内容：</div>
                <div class="cont-box" v-html="noticeInfo.noticeContent"></div>
            </div>
            <div class="cont-upload" v-if="noticeInfo.noticeType && noticeInfo.noticeType !== NOTICE_TYPE_PROJECT">
                <div class="upload-enclosure">
                    <div class="title">附件文档</div>
                </div>
                <div class="cont-upload-mt">
                    <el-table :data="moduleFileInfo" class="cont-upload-tab" border tooltip-effect='dark'>
                        <el-table-column prop="fileName" label="附件名称"  width="480"></el-table-column>
                        <el-table-column prop="createTime" label="上传时间" width="480"></el-table-column>
                        <el-table-column prop="address" label="操作">
                            <template slot-scope="scope">
                                <span v-has="'02000005'"><el-button size="mini" type="text" @click="actionFn(scope.row, '0')">预览</el-button></span>
                                <span v-has="'02000006'" class="margin-left"><el-button v-if="scope.row.createTime !== ''" size="mini" type="text"
                                    @click="actionFn(scope.row, '1')">下载</el-button></span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { filePreview } from '@/utils/filePreview.js';
import { getSupNotice, moduleFile, signUp, checkIsBlackSupplier } from '../../../../lsrm/api/annoMana.js';
import { dictWithUrl } from '@/components/lots/api';

const NOTICE_TYPE_BID = '20'; // SU_NOTICE_TYPE 公告类型-招标公告
const BID_TYPE_PUBLIC = '20'; // SU_BID_TYPE 招标方式-公开招标
const NOTICE_TYPE_PROJECT = '40'; // 项目公告
export default {
    data() {
        return {
            NOTICE_TYPE_BID,
            NOTICE_TYPE_PROJECT,
            moduleFileInfo: [], // 附件列表
            loadup: false, // 是否加载完
            textarea2: '',
            noticeInfo: {},
            timeFlag: false,
            dictData: [],
            signload: false,
            isBlack: false
        };
    },
    computed: {
        signableForBlack() {
            const { noticeType, bidType } = this.noticeInfo;
            // 公告类型为中标公告，招标方式为公开招标，是黑名单供应商
            return !(noticeType === NOTICE_TYPE_BID && bidType === BID_TYPE_PUBLIC && this.isBlack);
        }
    },
    mounted() {
        dictWithUrl('SU_NOTICE_TYPE').then(item => {
            this.dictData = item.data;
            const { supplierCode } = this.$store.state.supplier;
            getSupNotice({ id: this.$route.query.id, supplierCode }).then((res) => {
                if (+res.code === 0) {
                    this.noticeInfo = this.conversionData(res.data);
                    if (res.timestamp && this.noticeInfo.enrollEndTime) {
                        const timestamp = res.timestamp.replace(' ', 'T');
                        const enrollEndTime = this.noticeInfo.enrollEndTime.replace(' ', 'T');
                        this.timeFlag = new Date(timestamp).getTime() < new Date(enrollEndTime).getTime();
                    }
                    if (this.noticeInfo.noticeType !== NOTICE_TYPE_PROJECT) {
                        this.getFile(res);
                    }
                }
            });
            checkIsBlackSupplier(supplierCode).then(res => {
                if (res && +res.code === 0) {
                    this.isBlack = res.data;
                }
            });
        });
    },
    methods: {
        getFile(res) {
            moduleFile({ moduleNo: res.data.noticeCode, moduleTypes: ['9'], fileAttributes: ['23'] }).then((res) => {
                if (+res.code === 0 && res.data !== null) {
                    this.moduleFileInfo = res.data.list;
                    this.loadup = true;
                }
            });
        },
        signUpFn(noticeType = '') {
            this.signload = true;
            const par = {
                noticeCode: this.noticeInfo.noticeCode,
                supplierCode: this.$store.state.supplier.supplierCode,
                supplierName: this.$store.state.supplier.supplierNameCn,
                userCode: this.$store.state.user.userCode
            };
            if (noticeType) {
                par.noticeType = noticeType;
            }
            signUp(par).then(res => {
                this.signload = false;
                if (res && +res.code === 0) {
                    this.$message.success('报名成功');
                    this.noticeInfo.supplierBidStatus = 'Y';
                }
            });
        },
        conversionData(el) {
            const obj = {};
            obj.noticeTypeText = this.dictData.SU_NOTICE_TYPE[el.noticeType];
            return { ...el, ...obj };
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else {
                filePreview(row);
            }
        },
        buyBid() {
            this.$router.push({
                name: 'myBidding',
                query: {
                    noticeCode: this.noticeInfo.noticeCode
                }
            });
        }
    }
};
</script>

<style lang="less">
.preview-notice {
    margin: 10px 10px 0;
    background: #fff;
    font-size: 12px;
    .margin-left {
        margin-left: 10px;
    }
    .topNav {
        width: 100%;
        height: 46px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
    }
    .content {
        padding: 20px 20px 20px 30px;
        min-height: calc(~"100vh - 138px") !important;
        max-height: calc(~"100vh - 138px") !important;
        overflow-y: auto;
        .content-box {
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;
        }
        .color-9 {
            color: #999;
        }
        .title {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 15px;
        }
        .content-span {
            color:#333;
            margin-right:20px;
        }
        .upload-enclosure {
            width:100%;
            display: flex;
            justify-content: space-between;

        }
        .cont-box {
            border: 1px solid #CECECE;
            border-radius: 4px;
            min-height: 200px;
            max-height: 500px;
            overflow-y: auto;
            padding: 0 8px;
        }
        .cont-mb {
            margin-bottom: 15px;
        }
        .cont-mb-title {
            padding: 15px 0 10px;
        }
        .cont-upload {
            width:100%;
            margin-top:20px;
        }
        .cont-upload-mt {
            margin-top:10px;
        }
        .cont-upload-tab {
            width: 100%;
        }
    }
}

</style>